/**
 * 디버그 메뉴 unlock 토큰 검증 API.
 *
 * BE: POST /api/v1/user/debug/verify-token
 *   request:  { token: string }
 *   response: { valid: boolean, enabled: boolean }
 *
 * - enabled=false 또는 token 미설정 시 valid=false 로 응답 (BE 가 enabled 도 안내)
 * - 익명 호출 가능 (SecurityConfig 에 permitAll 등록).
 */
import { apiGet, apiPost } from "./client";

export interface VerifyTokenResponse {
  valid: boolean;
  enabled: boolean;
}

/** be 가 현재 resolve 하는 시스템 설정 값 (전파 검증용). */
export interface SystemConfigSnapshotEntry {
  code: string;
  value: string | null;
  error: string | null;
}

export interface SystemConfigSnapshot {
  configs: SystemConfigSnapshotEntry[];
}

export const debugApi = {
  verifyToken: (token: string): Promise<VerifyTokenResponse> =>
    apiPost<VerifyTokenResponse>("/debug/verify-token", { token }),
  /**
   * 시스템 설정 전파 검증 스냅샷.
   * 서버측 게이트: JWT 인증 필수 + BE debug.enabled=true. 비활성 시 403.
   */
  systemConfigs: (): Promise<SystemConfigSnapshot> =>
    apiGet<SystemConfigSnapshot>("/debug/system-configs"),
};
